const PREFIX = "@ins/reports"
export const REPORT_ADD_PENDING = `${PREFIX} ADD_PENDING`
export const REPORT_REMOVE_PENDING = `${PREFIX} REMOVE_PENDING`


const ReportActions = {}


ReportActions.addPending = (uuid, isDemo) => {
  return {
    type: REPORT_ADD_PENDING,
    uuid,
    isDemo
  }
}

ReportActions.removePending = (uuid) => {
  return {
    type: REPORT_REMOVE_PENDING,
    uuid
  }
}


export const addReportPending = ReportActions.addPending
export const removeReportPending = ReportActions.removePending


export default ReportActions
